import VSpace from "../components/common/VSpace"
import InvoicingSettings from "../components/settings/invoicing/InvoicingSettings"

const InvoicingSettingsPage = () => {
  return <div style={{backgroundColor: 'white'}}>
    <VSpace>
      <div style={{fontSize: '24px', fontWeight: 'bold', padding: '20px'}}>Invoicing Settings</div>
      <InvoicingSettings />
    </VSpace>
  </div>
}

export default InvoicingSettingsPage
